import React from "react";

const Logo = ({ className = "h-5 w-5" }) => (
  <svg
    className={className}
    viewBox="-62 -12 124 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M-60 0L-42 -10L-24 0L-42 10Z" fill="var(--theme-text)" opacity="0.45" />
    <path d="M-18 0L0 -10L18 0L0 10Z" fill="var(--theme-text)" opacity="0.45" />
    <path d="M24 0L42 -10L60 0L42 10Z" fill="#38BDF8" />
    <path d="M-39 12L-21 2L-3 12L-21 22Z" fill="var(--theme-text)" opacity="0.45" />
    <path d="M3 12L21 2L39 12L21 22Z" fill="var(--theme-text)" opacity="0.8" />
    <path d="M-18 24L0 14L18 24L0 34Z" stroke="var(--theme-text)" strokeWidth="1.3" opacity="0.45" fill="none" />
  </svg>
);

export default Logo;
